<template>
  <div class="d-flex flex-column justify-content-start align-items-center">
    <div class="d-flex flex-xl-row flex-lg-column flex-md-column flex-sm-row justify-content-center align-items-center cursor-pointer my-3" v-b-modal="viewModalID" v-if="prizes">
      <template v-for="i in [ 'first', 'second', 'third' ]">
        <b-img v-if="prizes[i] && prizes[i].image && prizes[i].image.fileLocation" class="border img-fit-cover mx-1 mb-2"
          :key="i" :src="prizes[i].image.fileLocation" :alt="prizes[i].title" height="100" width="100"/>
      </template>
    </div>

    <b-table :fields="[ 'position', 'name', 'points' ]" :items="topRows" primary-key="entryID"
      class="m-0" thead-class="d-none">

        <template #head(position)>{{ raffleMode ? '🎟' : '🏆' }}</template>
        <template #cell(position)="{ item: { isDivider, points, position } }">
          <template v-if="!isDivider">
            <template v-if="points > 0">
              <template v-if="raffleMode">🎟</template>
              <img src="/static/images/icons/medals/gold-medal.svg" alt="First Place" v-else-if="position=== 0"/>
              <img src="/static/images/icons/medals/silver-medal.svg" alt="Second Place" v-else-if="position === 1"/>
              <img src="/static/images/icons/medals/bronze-medal.svg" alt="Third Place" v-else-if="position === 2"/>
              <template v-else>{{position + 1}}</template>
            </template>
            <template v-else>-</template>
          </template>
        </template>

        <template #cell(name)="{ item: { isDivider }, value }">
          <template v-if="isDivider">...</template>
          <template v-else>{{ value }}</template>
        </template>

    </b-table>
  </div>
</template>

<script>
import { mapRoot } from '@src/mixins/root';

export default {
  props: {
    raffleMode: {
      type: Boolean,
      default: false,
    },
    prizes: {
      type: Object,
      default: null,
    },
    rows: {
      type: Array,
      required: true,
    },
    viewModalID: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapRoot([ 'userID' ]),
    topRows() {
      const rows = (Array.isArray(this.rows) ? this.rows : []).filter(({ user }) => user).map(({ id, user, points }, i) => ({
        id,
        position: i,
        points,
        name: user.fullName
      }));
      const i = rows.findIndex(r => r && r.user && r.user.id === this.userID);
      return i < 5 ? rows.slice(0, 5) : [ ...rows.slice(0, 3).map, { isDivider: true }, rows[i] ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/campaign/LeaderboardList.vue